var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showForm)?_c('Form',{attrs:{"form":_vm.form}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }